import moment from 'moment'
import Image from 'next/image'
import styled from 'styled-components'

import config from '@/config/index'
import { useWhiteLabelling } from '@/context/whiteLabelContext'
import { useBreakpoint } from '@/hooks/useBreakpoint'

const Footer = styled.footer`
  grid-area: footer;
  height: 3rem;
  margin-left: 1.75rem;
  margin-right: 6rem; // live chat
  border-top: 1px solid ${({ theme }) => theme.colour.secondary._100};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  ${({ theme }) => theme.media.md`
    gap: 1rem;
  `}
`

const Links = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  ${({ theme }) => theme.media.md`
    gap: 1rem;
  `}
`

const FooterLink = styled.a`
  ${({ theme }) => theme.font.caption01}
  color: ${({ theme }) => theme.colour.secondary._700};

  &:hover,
  &:focus,
  &:active {
    color: ${({ theme }) => theme.colour.secondary.base};
    text-decoration: underline;
  }
`

const OnlyDesktop = styled.span`
  display: none;

  ${({ theme }) => theme.media.lg`
    display: inline-block;
  `}
`

const Copyright = styled(OnlyDesktop)`
  ${({ theme }) => theme.font.caption01}
  color: ${({ theme }) => theme.colour.secondary._700};
  display: none;

  ${({ theme }) => theme.media.lg`
    display: inline-block;
  `}
`

export const CorePageFooter = () => {
  const isSmall = useBreakpoint('sm')
  const { logoResponsive } = useWhiteLabelling()

  return (
    <Footer>
      <Image
        src={logoResponsive}
        width={isSmall ? 24 : 100}
        height={isSmall ? 24 : 32}
        alt="Company logo"
        style={{ objectFit: 'contain' }}
      />

      <Links>
        <FooterLink
          href={config.legalLinks.privacyPolicy}
          target="_blank"
          rel="noreferrer"
        >
          Privacy & Policy
        </FooterLink>
        <span> | </span>
        <FooterLink
          href={config.legalLinks.termsOfService}
          target="_blank"
          rel="noreferrer"
        >
          Terms of Service
        </FooterLink>
        <OnlyDesktop> | </OnlyDesktop>
        <Copyright>
          © BuildPass {moment().year()}. All rights reserved.
        </Copyright>
      </Links>
    </Footer>
  )
}
